module.exports = __webpack_public_path__ + "static/media/IMG_1198.b0564e18.JPG";